import { Injectable } from '@angular/core';
import { HttpService } from '@core';
import { environment } from 'src/environments/environment';
import { PreferredMedicationRequestInterface, PreferredMedicationFileApiResponse } from '@interfaces';
import { convertJSONToQueryParams } from 'src/app/util';
import { HttpClient } from '@angular/common/http';
import { APIConstants } from 'src/app/services/service.constant';

@Injectable({
  providedIn: 'root',
})
export class PreferredMedicationService {
  constructor(private httpService: HttpService, private http: HttpClient) { }

  getPreferredMedicationList(reqBody: PreferredMedicationRequestInterface) {
    const query = convertJSONToQueryParams(reqBody);
    const url = `${environment.apiGatewayBaseURL}${APIConstants.PREFERRED_MEDICATION}?subscription-key=${environment.ocpApimSubscriptionKey}&${query}`;
    // console.log('Preferred medications URL:', url);
    return this.http.get<PreferredMedicationFileApiResponse>(url);
  }
}
